  const examCenterCodes = [
    { "001": "Malad" },
    { "002": "Pune" },
    { "003": "Vasai" },
    { "004": "Dabhoi_Kadadhara" },
    { "005": "Vadodara_Vyaara" },
    { "006": "Varsada" },
    { "007": "Barkal" },
    { "008": "Surat_Simada" },
    { "009": "Surat_Amroli" },
    { "010": "Surat_Nirmalnagar" },
    { "011": "Surat_Ashvinikumar" },
    { "012": "Surat_Laturiya" },
    { "013": "Surat_Rander" },
    { "014": "Surat_Gadhpur" },
    { "015": "Surat_Mota_Varacha" },
    { "016": "Surat_Shreeji_Mandir" },
    { "017": "Surat_Katargam" },
    { "018": "Kalol" },
    { "019": "Sankheda" },
    { "019": "Sankheda_Khunvad" },
    { "019": "Sankheda_Mankani" },
    { "019": "Sankheda_Amalpur" },
    { "020": "Chelana_Timbi" },
    { "021": "Keshod" },
    { "022": "Navsari" },
    { "023": "Godhra" },
    { "024": "Rajkot" },
    { "025": "Veraval" },
    { "026": "Sasan" },
    { "027": "Talala" },
    { "028": "Kodinar" },
    { "029": "Chhaliyer" },
    { "030": "Mira_Road" },
    { "031": "Junagadh" },
    { "032": "Anand" },
    { "032": "Bamangam" },
    { "032": "Karamsad" },
    { "032": "Vadtal" },
    { "032": "Vidhyanagar" },
    { "032": "Amerli" },
    { "033": "Padra" },
    { "033": "Virpar" },
    { "033": "Joshipura" },
    { "034": "Palaj_Piplav" },
    { "035": "Uttarsanda" },
    { "035": "Nadiad" },
    { "035": "Ramol_Nadiad" },
    { "036": "Petlad" },
    { "036": "Virsad" },
    { "036": "Khambhat" },
    { "036": "Dharmaj" },
    { "037": "Kheda" },
    { "037": "Memhmedabad_Kheda" },
    { "037": "Hajiarabad_Kheda" },
    { "038": "Palana" },
    { "039": "Sojitra" },
    { "039": "Piplav" },
    { "040": "Dombivali" },
    { "041": "Bhavnagar" },
    { "042": "Piparala" },
    { "043": "Mota_Samdhiyala" },
    { "043": "Una" },
    { "044": "Ankleshwar" },
    { "045": "Bilimora" },
    { "045": "Chikhli_Bilimora" },
    { "045": "Degam_Bilimora" },
    { "046": "Bantwa" },
    { "047": "Borivali" },
    { "048": "Vadodara" },
    { "049": "Utraj" },
    { "050": "Ahmedabad" },
    { "051": "Bharuch" },
    { "052": "Dahisar" },
    { "053": "Visavadar" },
    { "054": "Manavadar" },
    { "055": "Navda" },
    { "055": "Bodka_Navda" },
    { "055": "Sarangpipdi_Navda" },
    { "056": "Ambaliya_Ghed" },
    { "057": "Surat_Prerana" },
    { "058": "Surat_RiveraGreens" },
    { "059": "Surat_Kamrej" },
    { "060": "Dhareshwar" },
    { "061": "Kharghar" },
    { "062": "Agatrai" },
    { "063": "Bhuleshwar" },
    { "064": "Botad" },
    { "065": "Bhupgadh" },
    { "066": "Gadhada" },
    { "067": "Shankarpara" },
    { "068": "Kandivali" },
    { "069": "Savarkundla"},
    { "070": "Jetpur"},
    { "071": "Palasva"},
    { "072": "Bhadam"}

    ];

    export default examCenterCodes;
